"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStore = exports.StoreProvider = exports.StateContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactCombineReducers = _interopRequireDefault(require("react-combine-reducers"));

var _cryptHelper = require("../utils/cryptHelper");

var _appointment = require("./appointment");

var _appSettings = require("./appSettings");

var _assessment = require("./assessment");

var _customerInformation = require("./customerInformation");

var _device = require("./device");

var _location = require("./location");

var _qsiteSettings = require("./qsiteSettings");

var _ticket = require("./ticket");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _combineReducers = (0, _reactCombineReducers["default"])({
  assessment: [_assessment.assessmentReducers, _assessment.assessmentState],
  appSettings: [_appSettings.appSettingsReducers, _appSettings.appSettingsState],
  qsiteSettings: [_qsiteSettings.qsiteSettingsReducers, _qsiteSettings.qsiteSettingsState],
  device: [_device.deviceReducers, _device.deviceState],
  customerInformation: [_customerInformation.customerInformationReducers, _customerInformation.customerInformationState],
  appointment: [_appointment.appointmentReducers, _appointment.appointmentState],
  ticket: [_ticket.ticketReducers, _ticket.ticketState],
  location: [_location.locationReducers, _location.locationState]
}),
    _combineReducers2 = _slicedToArray(_combineReducers, 2),
    rootReducerCombined = _combineReducers2[0],
    initialStateCombined = _combineReducers2[1];

var initialStateWithStorage;

if (sessionStorage.getItem(_cryptHelper.sessionKeyName)) {
  var decryptedStorage = (0, _cryptHelper.decrypt)(sessionStorage.getItem(_cryptHelper.sessionKeyName));
  initialStateWithStorage = _objectSpread(_objectSpread({}, initialStateCombined), decryptedStorage);
} else {
  initialStateWithStorage = initialStateCombined;
  sessionStorage.setItem(_cryptHelper.sessionKeyName, (0, _cryptHelper.encrypt)(initialStateWithStorage));
} // Application Store


var StateContext = /*#__PURE__*/_react["default"].createContext();

exports.StateContext = StateContext;

var StoreProvider = function StoreProvider(_ref) {
  var children = _ref.children,
      reducersAndState = _ref.reducersAndState;
  var contextReducersAndState = reducersAndState !== null && reducersAndState !== void 0 ? reducersAndState : (0, _react.useReducer)(rootReducerCombined, initialStateWithStorage);
  (0, _react.useEffect)(function () {
    var _contextReducersAndSt = _slicedToArray(contextReducersAndState, 1),
        state = _contextReducersAndSt[0];

    sessionStorage.setItem(_cryptHelper.sessionKeyName, (0, _cryptHelper.encrypt)(state));
  });
  return /*#__PURE__*/_react["default"].createElement(StateContext.Provider, {
    value: contextReducersAndState,
    children: children
  });
};

exports.StoreProvider = StoreProvider;

var useStore = function useStore() {
  var store = (0, _react.useContext)(StateContext);

  if (window.Cypress) {
    window.__store__ = store;
  }

  return store;
};

exports.useStore = useStore;